import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthResponse } from '../../login/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordService {
  private readonly apiUrl = `${environment.apiUrl}`;

  readonly #http = inject(HttpClient);

  changePassword(
    oldPassword: string,
    newPassword: string,
  ): Observable<AuthResponse> {
    return this.#http.put<AuthResponse>(this.apiUrl + '/auth/change-password', {
      oldPassword,
      newPassword,
    });
  }
}
